var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"isActive":_vm.loading}}),_c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[(
        _vm.loadAuthorizationAction(
          'ADMIN_CONFIGURACAO',
          'CONFIGURACOES_AVANCADO'
        )
      )?_c('CTab',{attrs:{"title":"Avançado"}},[_c('h2',[_vm._v("As configurações aqui existentes foram mescladas com a aba de parâmetros")]),_c('router-link',{attrs:{"to":"/configuracoes/parametros"}},[_vm._v("Clique aqui para acessar")])],1):_vm._e(),(
        _vm.loadAuthorizationAction(
          'ADMIN_CONFIGURACAO',
          'CONFIGURACOES_INTEGRACOES'
        )
      )?_c('CTab',{attrs:{"title":"Integrações"}},[_c('Integracoes')],1):_vm._e(),(
        _vm.loadAuthorizationAction(
          'ADMIN_CONFIGURACAO',
          'CONFIGURACOES_TRADUCOES'
        )
      )?_c('CTab',{attrs:{"title":"Traduções"}},[_c('Traducoes')],1):_vm._e(),(
        _vm.loadAuthorizationAction('ADMIN_CONFIGURACAO', 'CONFIGURACOES_TEMAS')
      )?_c('CTab',{attrs:{"title":"Temas"}},[_c('Temas',{attrs:{"temas":_vm.temas,"salvarTema":_vm.salvarTema}})],1):_vm._e(),(
        _vm.temSistemaFV &&
        _vm.loadAuthorizationAction(
          'ADMIN_CONFIGURACAO',
          'CONFIGURACOES_FORCA_VENDAS'
        )
      )?_c('CTab',{attrs:{"title":"Força de Vendas"}},[_c('ForcaVendas')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }